/** Rótulos de criação e de estado vazio de um cadastro, com o gênero certo (Nova/Novo, Nenhuma/Nenhum). */
export interface EntradaRotulosCadastro {
  readonly singular: string;
  readonly genero: 'f' | 'm';
}

export interface RotulosCadastro {
  /** Texto do botão de criar: 'Nova Estufa', 'Novo Serviço / Etapa'. */
  readonly novo: string;
  /** Texto do estado vazio: 'Nenhuma estufa cadastrada ainda.'. */
  readonly vazio: string;
}

export function rotulosCadastro({ singular, genero }: EntradaRotulosCadastro): RotulosCadastro {
  const feminino = genero === 'f';
  return {
    novo: `${feminino ? 'Nova' : 'Novo'} ${singular}`,
    vazio: `${feminino ? 'Nenhuma' : 'Nenhum'} ${singular.toLowerCase()} ${feminino ? 'cadastrada' : 'cadastrado'} ainda.`,
  };
}
